// StudentItem.js (adaptación al nuevo SCSS)
import React, { useState } from "react";
import { Image, Button, Icon, Confirm } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { StudentForm } from "../../TeacherCmp/TeacherForm";
import { StudentAPI } from "../../../../api";
import { useTranslation } from "react-i18next";
import "./StudentItem.scss";

const studentController = new StudentAPI();

export function StudentItem(props) {
  const { student, onReload, institution, accessToken } = props;
  const { t } = useTranslation("students");
  const [showModal, setShowModal] = useState(false);
  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const [showConfirm, setShowConfirm] = useState(false);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const onDelete = async () => {
    try {
      // Aquí debería llamar a un método deletestudent, no getstudentById
      await studentController.deleteStudent(
        accessToken,
        institution,
        student._id,
      );
      console.log("Docente borrado", student._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="student-item">
        <div className="student-item__image">
          <Image src={student.avatar} />
        </div>
        <div className="student-item__content">
          <div className="student-item__info-title">
            <h2>
              {student.name} {student.surname}
            </h2>
          </div>
          <div className="student-item__info-path">
            <p>{student.email}</p>
          </div>
          <div className="student-item__info-path">
            <p>{student.classnumber}</p>
          </div>
          <div className="student-item__buttons">
            <Button icon primary onClick={onOpenCloseModal}>
              <Icon name="pencil" />
            </Button>
            <Button icon color="red" onClick={onOpenCloseConfirm}>
              <Icon name="trash" />
            </Button>
          </div>
        </div>
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={t("item.editLabel")}
        size="small"
      >
        <StudentForm
          student={student}
          onClose={onOpenCloseModal}
          onReload={onReload}
        />
      </BasicModal>
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`${t("item.deleteConfirm")} ${student.name}?`}
        size="mini"
      />
    </>
  );
}
